import { useTranslations } from "next-intl";
import Image from "@components/core/Image";
import Link from "@components/core/LinkApp";

const LgdLinks = () => {
  const t = useTranslations("common");

  return (
    <div className="d-flex flex-column w-50 mb-sm-0">
      <div className="d-flex mb-md-0">
        <section className="d-flex flex-column w-75">
          <h3>{t("footer.services")}</h3>
          <Link
            href={t("footer.links.help_center.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.help_center.text")}
          </Link>
          <Link
            href={t("footer.links.contact_us.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("footer.links.contact_us.text")}
          </Link>
        </section>

        <section className="d-flex flex-sm-column ms-3">
          <div className="mb-sm-4">
            <h3>{t("footer.network")}</h3>
            <div className="d-flex">
              <a
                href="https://www.facebook.com/legranddressing/"
                className="link-dark me-2"
                target="_blank"
                rel="noreferrer"
              >
                <div style={{ width: "13px" }}>
                  <Image
                    src="facebookFooter"
                    alt="logo facebook"
                    className="w-100"
                  />
                </div>
              </a>

              <a
                href="https://www.instagram.com/legranddressing/"
                className="link-dark me-2"
                target="_blank"
                rel="noreferrer"
              >
                <div style={{ width: "1.5rem" }}>
                  <Image
                    src="instagram"
                    alt="logo instagram"
                    className="w-100"
                  />
                </div>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LgdLinks;
